export default {
  title: 'PayPal (direkt)',
  description:
    'Verbinde dein eigenes PayPal-Geschäftskonto, um PayPal-Zahlungen direkt und zu deinem eigenen Tarif zu erhalten. Erstelle eine REST-App im PayPal Developer Dashboard und füge unten Client-ID und Secret ein.',
  connected_description: 'Dein PayPal-Konto ist verbunden. Zahlungen gehen direkt darauf ein.',
  guide: {
    title: 'So erhältst du deine PayPal-Zugangsdaten',
    step1: 'Melde dich mit deinem PayPal-Geschäftskonto im PayPal Developer Dashboard an.',
    step2: 'Öffne „Apps & Credentials“ und erstelle eine App (oder öffne deine bestehende).',
    step3: 'Kopiere Client-ID und Secret der App.',
    step4: 'Füge sie unten ein und klicke auf „PayPal verbinden“.',
    environment_note:
      'Verwende deine Live-Zugangsdaten für echte Zahlungen — nutze den Sandbox/Live-Schalter oben in „Apps & Credentials“.',
    open_dashboard: 'PayPal Developer Dashboard öffnen',
  },
  status: {
    connected: 'Verbunden',
  },
  fields: {
    client_id: {
      label: 'Client-ID',
      placeholder: 'Client-ID deiner PayPal REST-App',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Secret deiner PayPal REST-App',
    },
  },
  buttons: {
    connect: 'PayPal verbinden',
    disconnect: 'Trennen',
  },
  toasts: {
    connected: 'PayPal erfolgreich verbunden',
    connect_failed: 'PayPal konnte nicht verbunden werden',
    disconnected: 'PayPal getrennt',
    disconnect_failed: 'PayPal konnte nicht getrennt werden',
  },
};
